// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".marquee-section{position:relative}.marquee-section .icon-section{position:absolute;top:0;right:0}.marquee-section .icon-section :hover{color:red}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
